var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"elevation":"3"}},[_c('v-toolbar',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Delivery information for Alco agency code: "+_vm._s(_vm.id))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }